module.exports = __webpack_public_path__ + "first.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/first.svg?color1=%23333333&color2=
// module id = 912
// module chunks = 67